import { useQuery } from "@apollo/client";
import { OrganizationThemeQueryDocument } from "./graphql/OrganizationThemeQuery.b2b.generated.js";
const useOrganizationTheme = (organizationSlug, args)=>{
    const skip = args?.skip || !organizationSlug;
    const { data, loading, error } = useQuery(OrganizationThemeQueryDocument, {
        context: {
            clientName: 'b2b'
        },
        variables: {
            slug: organizationSlug
        },
        skip
    });
    return {
        data: data?.organizationInfo,
        loading,
        error
    };
};
const useOrganizationTheme_useOrganizationTheme = useOrganizationTheme;
export default useOrganizationTheme_useOrganizationTheme;
